<template>
    <div class="out-box" :style="styleConfig.width?(`width:${styleConfig.width};height:${styleConfig.height};`):''">
        <label :class="formatClassByType(backgroundType)">
            <img v-if="picShow" :src="imgShow" alt="" >  
        </label>
        <p v-if="showFileName" class="doc_name_wrapper">
            <em v-if="picShow" class="el-icon-view" @click="openImgPreview"></em>
            <span class="doc_name" @click="openImgPreview()">{{docNameCopy}}</span>
        </p>
        <el-dialog
                :title="backgroundTypeTransformation(backgroundType)"
                :append-to-body="true"
                class="imgDialogView"
                :show-close="false"
                :visible.sync="centerDialogVisible"
                width="50%"
                center>
            <span style="display: flex;align-items: center;justify-content: center">
                 <img ref="rotateImg" v-if="picShow" :src="imgShow" style="width:90%;" alt="">
            </span>
            <div style="display: flex;align-items: center;justify-content: space-between">
                <el-button @click="rotate(0)">左旋转</el-button>
                <el-button @click="rotate(1)">右旋转</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        props:{
            fileName: {
                type: String,
                required: true
            },
            backgroundType: {
                type: Number,
            },
            imgUrl: {
                type: String,
            },
            styleConfig:{
                type:Object,
                default:()=>{return {}}
            }
        },
        computed:{
            docNameCopy: {
                get () {
                    return this.fileName
                }
            },
            showFileName: {
                get () {
                    return this.docNameCopy != ''
                }
            },
        },
        watch:{
            imgUrl:{
                deep:true,
                immediate:true,
                handler(val){
                   this.imgUrlCopy=val
                   if(this.imgUrlCopy){
                    this.getImgUrl(this.imgUrlCopy);
                    }
                }
            }
        },
        data(){
            return {
                picShow:false,
                centerDialogVisible:false,
                imgShow:'',
                fileInfo:{
                    deg:0
                },
                imgUrlCopy:''
            }
        },
        mounted(){
          
        },
        methods:{
            //backgroundType 图片上传组件背景参数 1-> 营业执照 2-> 身份证正面 3-> 身份证反面 4-> 基本户扫描件 5-> 资质证书
            formatClassByType(type){
                switch(type){
                    case 1 : return 'show-img do-business' ; break;
                    case 2 : return 'show-img id-card-another' ; break;
                    case 3 : return 'show-img id-card-positive' ; break;
                    case 4 : return 'show-img basic-scanning' ; break;
                    case 5 : return 'show-img qualification-certificate' ; break;
                    default : return '' ; break;
                }

            },
            //获取图片
            getImgUrl(filePath){
                this.$httpReq({
                    method: 'get',
                    url: '/sys/upload/downfile?filePath=' + encodeURI(filePath),
                    responseType: 'blob'
                }).then(res => {
                    var typeName = filePath.split(".")[1];
                    let blob = new Blob([res.data], {type: 'application/' + typeName + ''})
                    this.imgShow = window.URL.createObjectURL(blob);
                    this.picShow = true;
                })
            },
            //预览图片
            openImgPreview(){
                this.centerDialogVisible = true;
            },
            //backgroundType 图片上传组件背景参数 1-> 营业执照 2-> 身份证正面 3-> 身份证反面 4-> 基本户扫描件 5-> 资质证书
            backgroundTypeTransformation(val){
                switch(val){
                    case 1 : return '营业执照' ; break;
                    case 2 : return '身份证正面' ; break;
                    case 3 : return '身份证反面' ; break;
                    case 4 : return '基本户扫描件' ; break;
                    case 5 : return '资质证书' ; break;
                    default : return '' ; break;
                }
            },
            rotate (val) {
                if(val == 0){
                    console.log('left')
                    this.fileInfo.deg -= 90;
                    if (this.fileInfo.deg <= -360) {
                        this.fileInfo.deg = 0
                    }
                }else{
                    this.fileInfo.deg += 90;
                    if (this.fileInfo.deg >= 360) {
                        this.fileInfo.deg = 0
                    }

                }
                this.$refs.rotateImg.style.transform = `rotate(${this.fileInfo.deg}deg)`;
                // this.$refs.rotateImg.style.width = '70%';
                // this.$refs.rotateImg.style.height = '70%';
            }
        }
    }
</script>
<style>
    .imgDialogView .el-dialog{
        background: inherit;
        box-shadow: none;
    }
</style>
<style lang="scss" scoped>
    .out-box {
        width: 300px;
        height: 186px;
        position: relative;
        margin: 0 0 28px 0;
        .show-img {
            display: inline-block;
            width: 100%;
            height: 100%;
            cursor: pointer;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .do-business {
            background: url("../../assets/img/yingyezhizhao.png") no-repeat center center;
        }

        .id-card-positive {
            background: url("../../assets/img/id-card-positive.png") no-repeat center center;
        }

        .id-card-another {
            background: url("../../assets/img/id-card-another.png") no-repeat center center;
        }

        .basic-scanning {
            background: url("../../assets/img/basic-scanning.png") no-repeat center center;
        }

        .qualification-certificate {
            background: url("../../assets/img/qualification-certificate.png") no-repeat center center;
            background-size: 100% 100%;
        }

        p.doc_name_wrapper{
            width: 300px;
            height: 30px;
            line-height: 28px;
            position: absolute;
            bottom: -40px;
            cursor: pointer;
            border-bottom: 1px solid #dcdfe6;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            .doc_name{
                margin-left: 6px;
                display: inline-block;
                border-bottom: 1px solid #1890FF;
                position: relative;bottom: -1px;

            }
            .deleteIcon{
                position: absolute;
                right:0;
            }
        }

    }
    @media screen and (max-width: 1600px){
        .out-box{
            width: 200px;
            height: 140px;
            p.doc_name_wrapper{
                width: 200px;
            }
            .show-img{
                width: 200px;
                height: 140px;
            }

        }
    }
</style>